import apiClient from './apiClient';

export async function requestVerificationCode(idToken, email) {
  // This function is called with the idToken, but our apiClient handles that.
  // We can simplify this to not require the token as an argument.
  return apiClient.post('request-code', { email });
}

export async function verifyEmailCode(idToken, email, code) {
  // Same as above, the apiClient will get the token.
  return apiClient.post('verify-code', { email, code });
}